(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[437],{

/***/ 82659:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vefverslun",
      function () {
        return __webpack_require__(22955);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CategoryCard; }
/* harmony export */ });
/* unused harmony export IconContainer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28698);
/* harmony import */ var remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var _themes_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69431);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56795);
/* harmony import */ var _styles_shadowStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23633);
/* harmony import */ var _styles_imageStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 16px;\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  transition: background-color 0.15s;\n\n  ",
        " {\n    position: relative;\n    padding-top: 16px;\n    padding-bottom: 8px;\n\n    &:before {\n      position: absolute;\n      content: '';\n      top: 0;\n      left: 0;\n      width: 20px;\n      border-top: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transition: visibility 0.15s;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 250px;\n  margin-bottom: 20px;\n  transition: color 0.5s, border-color 0.5s, background-color 0.5s;\n  border: 1px solid transparent;\n  cursor: pointer;\n  ",
        ";\n\n  &:hover&:not(:disabled) {\n    border: 1px solid ",
        ";\n\n    ",
        " {\n      visibility: visible;\n    }\n  }\n\n  &:active {\n    ",
        " {\n      background-color: ",
        ";\n    }\n  }\n\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  &:focus,\n  &:focus-visible {\n    outline: 3px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var CategoryTitleBox = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("secondary"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black20"), _typography__WEBPACK_IMPORTED_MODULE_7__.H6, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red"));
var IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].div(_templateObject1());
var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__["default"].a(_templateObject2(), (0,_styles_shadowStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: true
}), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red"), IconContainer, CategoryTitleBox, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red10"), _styles_imageStyles__WEBPACK_IMPORTED_MODULE_9__/* .BackgroundImageCover */ .G, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("sky"));
function CategoryCard(param) {
    var src = param.src, title = param.title, description = param.description, href = param.href;
    if (!href) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardWrapper, {
            children: [
                src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles_imageStyles__WEBPACK_IMPORTED_MODULE_9__/* .BackgroundImageCover */ .G, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        layout: "fill",
                        objectFit: "contain",
                        objectPosition: "center",
                        src: src
                    })
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CategoryTitleBox, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightUpLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                color: _themes_theme__WEBPACK_IMPORTED_MODULE_6__/* ["default"].palette.red */ .Z.palette.red
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_7__.H6, {
                            children: title || "V\xf6ruflokkur"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_7__/* .PSmall */ .zK, {
                            color: "black40",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 70857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ PageContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20929);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49012);



var PageContent = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? src_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.title */ .D.title : _title, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_2__/* .PageContainer */ ._z, {
        title: "".concat(label, " - ").concat(title),
        children: children
    });
};


/***/ }),

/***/ 39884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ PageContent/* PageContent */.J; },
  "S": function() { return /* reexport */ PageLoading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(20929);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/components/genericPage/PageContent.tsx
var PageContent = __webpack_require__(70857);
;// CONCATENATED MODULE: ./src/components/genericPage/PageLoading.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 80vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var LOADING_LABEL = "S\xe6ki \u2026";
var LoaderWrapper = styled_components_browser_esm["default"].div(_templateObject());
var PageLoading = function(param) {
    var _title = param.title, title = _title === void 0 ? config/* Config.title */.D.title : _title, _loadingLabel = param.loadingLabel, loadingLabel = _loadingLabel === void 0 ? LOADING_LABEL : _loadingLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent/* PageContent */.J, {
        label: loadingLabel,
        title: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {})
        })
    });
};

;// CONCATENATED MODULE: ./src/components/genericPage/index.ts




/***/ }),

/***/ 20929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Config; }
/* harmony export */ });
var Config = {
    title: "Rekstrarv\xf6rur"
};


/***/ }),

/***/ 22955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Voruflokkar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49554);
/* harmony import */ var src_components_layout_PageContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78823);
/* harmony import */ var src_components_category_CategoryCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68164);
/* harmony import */ var src_components_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49012);
/* harmony import */ var src_components_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56795);
/* harmony import */ var src_components_products__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18254);
/* harmony import */ var src_utils_paths__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27827);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46829);
/* harmony import */ var src_components_genericPage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39884);
/* harmony import */ var src_utils_isSSR__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28095);
/* harmony import */ var src_utils_isNotNull__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(84403);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var DONOT_SHOW_SLUGS = [
    "baeklingar-sreh",
    "akstur-sref"
];
var DEFAULT_IMAGE = "/assets/voruspjald.png";
var __N_SSP = true;
function Voruflokkar() {
    var ref3;
    var ref1 = (0,src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_3__/* .useNavigationCategoriesQuery */ .nFH)(), data = ref1.data, error = ref1.error, loading = ref1.loading;
    var ref2 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_11__.useQuery)(src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_3__/* .CategoriesDocument */ .bby, {
        variables: {
            first: 100,
            level: 0
        }
    }), categoriesData = ref2.data, categoriesError = ref2.error, categoriesLoading = ref2.loading;
    var countObj = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (categoriesError || categoriesLoading || !(categoriesData === null || categoriesData === void 0 ? void 0 : categoriesData.categories)) {
            return {};
        }
        var ref;
        return categoriesData.categories.edges.filter(src_utils_isNotNull__WEBPACK_IMPORTED_MODULE_12__/* .isNotNull */ .K).reduce(function(a, b) {
            var ref4;
            return _objectSpread({}, a, _defineProperty({}, b.node.slug, (ref = (ref4 = b.node.products) === null || ref4 === void 0 ? void 0 : ref4.totalCount) !== null && ref !== void 0 ? ref : 0));
        }, {});
    }, [
        categoriesData === null || categoriesData === void 0 ? void 0 : categoriesData.categories,
        categoriesError,
        categoriesLoading
    ]);
    if (error) {
        // TODO: Better error handling
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_PageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            title: "Villa",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Container, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_7__.H2, {
                    children: "Villa"
                })
            })
        });
    }
    if (!src_utils_isSSR__WEBPACK_IMPORTED_MODULE_13__/* .isSSR */ .y && loading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_genericPage__WEBPACK_IMPORTED_MODULE_10__/* .PageLoading */ .S, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_PageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: "Allir v\xf6ruflokkar | Rekstrarv\xf6rur",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_products__WEBPACK_IMPORTED_MODULE_8__/* .Breadcrumbs */ .Oo, {
                    breadcrumbs: [
                        {
                            title: "Fors\xed\xf0a",
                            href: src_utils_paths__WEBPACK_IMPORTED_MODULE_9__/* .paths.home */ .H.home
                        },
                        {
                            title: "Vefverslun",
                            href: src_utils_paths__WEBPACK_IMPORTED_MODULE_9__/* .paths.categories */ .H.categories
                        }, 
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_layout__WEBPACK_IMPORTED_MODULE_6__/* .SpacingWrapper */ .$3, {
                    spacing: 32,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_7__.H1, {
                            withGutter: true,
                            children: "Vefverslun"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Row, {
                            children: ((data === null || data === void 0 ? void 0 : (ref3 = data.categories) === null || ref3 === void 0 ? void 0 : ref3.edges) || []).filter(function(e) {
                                return !DONOT_SHOW_SLUGS.includes(e.node.slug);
                            }).map(function(param) {
                                var node = param.node;
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Col, {
                                    md: 3,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_category_CategoryCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        title: node.name,
                                        href: "".concat(src_utils_paths__WEBPACK_IMPORTED_MODULE_9__/* .paths.categories */ .H.categories, "/").concat(node.slug),
                                        src: ((ref = node.backgroundImage) === null || ref === void 0 ? void 0 : ref.url) || DEFAULT_IMAGE,
                                        description: countObj[node.slug] ? "".concat(countObj[node.slug], " v\xf6rur") : ""
                                    })
                                }, node.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [370,12,774,888,179], function() { return __webpack_exec__(82659); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);